import React from 'react'

export default class Divider extends React.Component { 

	handleSpacing() { 
		if (this.props.style) { 
			return this.props.style
		} else { 
			return {paddingTop: '6%', paddingBottom: '6%'}
		}
	}

	render() { 
		return (
			<div style={this.handleSpacing()}> 
			<div style={{backgroundColor:'lightgray', height:1, width:'98%'}}></div>
			</div>
			)
	}

}